import type {
  eventWithTime,
  fullSnapshotEvent,
  Handler,
  metaEvent,
  playerConfig,
  listenerHandler,
  recordOptions,
  event,
  Arguments,
  incrementalSnapshotEvent,
  attributeMutation,
  mutationData,
} from 'rrweb/typings/types';
import type { serializedNode, attributes } from 'rrweb-snapshot/typings/types';

// NOTE: import enums from "rrweb", they will not work imported from "rrweb/typings/types"
import { EventType, IncrementalSource } from 'rrweb';

export {
  eventWithTime,
  fullSnapshotEvent,
  Handler,
  metaEvent,
  playerConfig,
  listenerHandler,
  recordOptions,
  event as RrwebEvent,
  Arguments,
  serializedNode,
  attributes,
  EventType,
  IncrementalSource,
  incrementalSnapshotEvent,
  attributeMutation,
  mutationData,
};

export type Rid = string;

export enum CustomRrwebEventTags {
  RECORDING_START_EVENT_TAG = 'sb-recording-start',
  IFRAME_LOADING_EVENT_TAG = 'sb-iframe-loading',
}

/** All of the custom state tracked in RRWeb events for use in recordings. */
export interface CustomRrwebState {
  isDisplayshare?: boolean;
  sentChatMessage?: boolean;
}

/** Custom event for updating custom state, only needs partial state */
export interface CustomRrwebStateEvent {
  type: EventType.Custom;
  data: {
    tag: 'sb-custom-state';
    payload: CustomRrwebState;
  };
}

export type RrwebEventMetaMode = 'iframe' | 'single';

export interface SbRrwebEventMeta {
  rid: string;
  mode: RrwebEventMetaMode;
  synthetic?: boolean;
}

export type SbRrwebEvent = eventWithTime & SbRrwebEventMeta;

export interface SbRrwebEvents {
  // refactor type & mode, they provide the same information
  type: 'rrwebWidgetEvent' | 'rrwebEvent';
  mode: RrwebEventMetaMode;
  events: Array<SbRrwebEvent>;
  rid: string;
}

export interface SbRrwebEventsEnvelope {
  type: 'event';
  event: SbRrwebEvents;
  nonce: number;
}

/** Rrweb event acknowledgements to be send back to the widget, confirming reception */
export type RrwebEventAcks = Record<string, Set<number>>;

/** Serializeable RrwebEventAcks, using an array instead of Set */
export type RrwebEventAcksSerializeable = Record<string, Array<number>>;
